/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics/FctParams';
import { LIDO_STETH_TOKEN } from '../constants';
export var GetPooledEthByShares = createPlugin({
    protocol: 'LIDO',
    type: 'GETTER',
    method: 'getPooledEthByShares',
    supportedContracts: LIDO_STETH_TOKEN,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                shares: new FctValue18({}),
            },
        },
        output: {
            ethAmount: new FctValue18({}),
        },
    }); },
});
